<template>
  <circle
    cx="8"
    cy="8"
    r="6.75"
    fill="#3769D6"
    stroke="#92AEEA"
    stroke-width="1.5"
  />
  <path
    d="M5 8L7 10L11 6"
    stroke="#EDF4FE"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</template>
